module.exports = __webpack_public_path__ + "assets/images/edge820-c698b3d4ac74851c641bfa78414f7e8a.jpg";